module.exports = __webpack_public_path__ + "static/fonts/icons.25a3241.eot";


//////////////////
// WEBPACK FOOTER
// ./~/semantic-ui-css/themes/default/assets/fonts/icons.eot
// module id = 150
// module chunks = 2